// extracted by mini-css-extract-plugin
export var blue = "Input-module--blue--3c17f";
export var dark = "Input-module--dark--954cc";
export var form_group = "Input-module--form_group--0fcf2";
export var hasMarginTop = "Input-module--hasMarginTop--63976";
export var inline = "Input-module--inline--5b61c";
export var input = "Input-module--input--50490";
export var label = "Input-module--label--b28e4";
export var noMarginBottom = "Input-module--noMarginBottom--d89c5";